module.exports = __webpack_public_path__ + "img/images-4.ae100d23.jpg";